import { DocUploadChecklist, DocUploadSession } from "./doc-upload"

const docUploadSession = new DocUploadSession()
const docUploadChecklist = new DocUploadChecklist()

export { docUploadSession, docUploadChecklist }
